
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Department Component
 * @param response has the backend
 * Department component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result: any = {
        departments: [],
        error: undefined
    }

    const { log } = context;
    if (response && response.status >= 400) {
        result.error = response;
    }
    if (response?.length > 0) {
        result.departments = response;
    }
    log.debug(
        "ccw-gadget,getalldepartments-athena",
        "getalldepartments-athena transformation response ", {
        result
    });
    return result;
}

